/* Dose — desktop-only UX (≥990px): no pre-selected grind, quick-add without Shop Pay. */
(() => {
  const mq = window.matchMedia('(min-width: 990px)');
  const chosen = new Set();
  const multi = (vp) => [...vp.querySelectorAll('fieldset')].filter((f) => f.querySelectorAll('input[type=radio]').length > 1);
  const rootOf = (el) => el.closest('dialog, .shopify-section, main') || document;
  const keyOf = (vp) => vp.dataset.productId + (vp.closest('dialog') ? ':qa' : ':pdp');
  const pending = (root) => [...root.querySelectorAll('variant-picker.dose-unpicked')];

  function reset(vp) {
    if (!mq.matches || vp.dataset.doseReset) return;
    vp.dataset.doseReset = '1';
    if (chosen.has(keyOf(vp))) return;
    if (!vp.closest('dialog') && new URLSearchParams(location.search).has('variant')) return; // deep link = explicit choice
    const sets = multi(vp);
    if (!sets.length) return;
    const clear = () => {
      if (chosen.has(keyOf(vp)) || !vp.isConnected) return guard.disconnect();
      sets.forEach((f) => f.querySelectorAll('input[type=radio]').forEach((r) => {
        if (r.checked || r.hasAttribute('checked')) { r.checked = false; r.removeAttribute('checked'); }
        r.dataset.currentChecked = 'false';
      }));
      if (!vp.classList.contains('dose-unpicked')) vp.classList.add('dose-unpicked');
      const root = rootOf(vp);
      if (!root.classList.contains('dose-needs-choice')) root.classList.add('dose-needs-choice');
    };
    // Horizon morphs quick-add / section content right after insert and re-checks the default: undo that until the user picks.
    const guard = new MutationObserver(clear);
    clear();
    guard.observe(vp, { attributes: true, subtree: true, attributeFilter: ['checked', 'class'] });
  }

  function nudge(root) {
    pending(root).forEach((vp) => {
      vp.classList.remove('dose-nudge'); void vp.offsetWidth; vp.classList.add('dose-nudge');
      vp.querySelector('input[type=radio]')?.focus({ preventScroll: false });
    });
  }

  document.addEventListener('change', (e) => {
    const vp = e.target.closest?.('variant-picker.dose-unpicked');
    if (!vp) return;
    const done = multi(vp).every((f) => f.querySelector('input[type=radio]:checked'));
    if (!done) return;
    chosen.add(keyOf(vp));
    vp.classList.remove('dose-unpicked', 'dose-nudge');
    const root = rootOf(vp);
    if (!pending(root).length) root.classList.remove('dose-needs-choice');
  }, true);

  // Block add-to-cart / buy until a grind is picked
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('button[name="add"], .dose-more-pay, shopify-accelerated-checkout');
    if (!btn) return;
    const root = rootOf(btn);
    if (!pending(root).length) return;
    e.preventDefault(); e.stopImmediatePropagation();
    nudge(root);
  }, true);

  // Quick-add: replace Shop Pay with a plain text link
  function addMorePay(dialog) {
    if (!mq.matches || dialog.querySelector('.dose-more-pay')) return;
    const block = dialog.querySelector('.accelerated-checkout-block');
    const form = dialog.querySelector('form[data-type="add-to-cart-form"]');
    if (!block || !form) return;
    const a = document.createElement('a');
    a.href = '/checkout'; a.className = 'dose-more-pay'; a.textContent = 'Mai multe opțiuni de plată';
    a.addEventListener('click', async (e) => {
      e.preventDefault();
      if (pending(rootOf(a)).length) return;
      a.setAttribute('aria-busy', 'true'); a.textContent = 'Se deschide plata…';
      const fd = new FormData(form); const body = { quantity: Number(fd.get('quantity') || 1), id: Number(fd.get('id')) };
      if (fd.get('selling_plan')) body.selling_plan = Number(fd.get('selling_plan'));
      try {
        const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        if (!r.ok) throw new Error();
        location.href = '/checkout';
      } catch { a.removeAttribute('aria-busy'); a.textContent = 'Mai multe opțiuni de plată'; }
    });
    block.after(a);
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    (node.matches('variant-picker') ? [node] : node.querySelectorAll('variant-picker')).forEach(reset);
    const qa = node.closest?.('.quick-add-modal') || node.querySelector?.('.quick-add-modal');
    if (qa) addMorePay(qa);
  }
  scan(document.body);
  new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach(scan))).observe(document.body, { childList: true, subtree: true });
})();
